export default {
    cognito: {
      REGION: "eu-west-2",
      USER_POOL_ID: "eu-west-2_mcJ1PPEW5",
      APP_CLIENT_ID: "5idn74ue3ninl2sd4cl8qld0ct",
      IDENTITY_POOL_ID: "eu-west-2:d58881a4-2094-496d-b85e-764e423cf933"
    }
  };